import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { Paged } from 'src/app/models/paged';
import { FilterCardSolicitation } from 'src/app/models/relatorio';
import { ExtractVehicles } from 'src/app/models/vehicle';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { VehicleService } from 'src/app/services/vehicles.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

@Component({
  selector: 'app-extrato-log-list',
  templateUrl: './extrato-log-list.component.html',
  styleUrls: ['./extrato-log-list.component.css']
})
export class ExtratoLogListComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private alertService: NewAlertService,
    private modalService: NgbModal,
    public datepipe: DatePipe,
    private authenticationService: AuthenticationService,
    private vehicleService: VehicleService
  ) { }

  private currentUser: Auth;
  public extractList: ExtractVehicles[];
  public filtroOn: boolean = false;
  public filterStartDate: Date = null;
  public filterEndDate: Date = null;

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    
    this.carregarExtrato(1);
  }

  carregarExtrato(page){
    this.currentPage = page;
    this.vehicleService.getExtract(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId,(page-1),+this.showItem,this.filterStartDate,this.filterEndDate)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.extractList = response.result.items;
        this.totalItems = response.result.total;   
      }
    });
  }

  showItemChanged(event) {
    this.showItem = event;
    this.carregarExtrato(1);
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  } 
  
  setPeriod(inicio,date: Date){
    date = new Date(date)
    if(inicio){
      this.filterStartDate = new Date(date.getFullYear()+"/"+(date.getMonth()+1)+"/"+date.getDate())
      console.log(this.filterStartDate)
    } else {
      this.filterEndDate = new Date(date.getFullYear()+"/"+(date.getMonth()+1)+"/"+date.getDate())
      console.log(this.filterEndDate)
    }

    if (this.filterEndDate && this.filterStartDate && this.filterEndDate < this.filterStartDate){
      let aux = this.filterStartDate;
      this.filterStartDate = this.filterEndDate;
      this.filterEndDate = aux;
    }
  }
 
  applyFilter() {
    console.log(this.filterStartDate)
    console.log(this.filterEndDate)

    if(
      this.filterStartDate == null &&
      this.filterEndDate == null 
    ){
      this.filtroOn = false;
      this.carregarExtrato(1);
      this.modalService.dismissAll();
    } else {
      this.filtroOn = true;
      this.carregarExtrato(1);
      this.modalService.dismissAll();
    }
  }

  deleteFilter(){
    
    this.filterStartDate = null;
    this.filterEndDate = null;

    this.filtroOn = false;

    this.carregarExtrato(1);
  }

}
